import { Coffee, MoonStar, Waves, TreePine } from "lucide-react";
import { Reveal } from "./Reveal";

const CAPITULOS = [
    { n: "01", icon: Coffee, titulo: "Manhãs de serra", texto: "Café da manhã incluso, servido com calma e o cheiro da mata." },
    { n: "02", icon: Waves, titulo: "Águas quentes", texto: "Piscina spa aquecida e hidromassagem para qualquer estação do ano." },
    { n: "03", icon: TreePine, titulo: "Natureza viva", texto: "Vista aberta da Serra da Moeda, cascata e o verde por todos os lados." },
    { n: "04", icon: MoonStar, titulo: "Noites de descanso", texto: "Jantar incluso, céu estrelado e o silêncio que só a serra tem." },
];

export default function Experiencia() {
    return (
        <section data-testid="experiencia-section" className="py-24 md:py-32 bg-[#EAE6DF]">
            <div className="max-w-7xl mx-auto px-4 md:px-8">
                <Reveal>
                    <p className="text-xs font-bold uppercase tracking-[0.3em] text-emerald-800 mb-4">A experiência</p>
                    <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-stone-900 leading-tight max-w-2xl">
                        Quatro capítulos de um fim de semana perfeito.
                    </h2>
                </Reveal>

                <div className="mt-16 md:mt-20 border-t border-stone-300">
                    {CAPITULOS.map((c, i) => (
                        <Reveal key={c.n} delay={i * 0.06}>
                            <div className="grid md:grid-cols-12 gap-4 md:gap-8 items-center py-8 md:py-10 border-b border-stone-300 group">
                                <span className="md:col-span-2 text-outline text-5xl md:text-6xl font-black leading-none select-none">
                                    {c.n}
                                </span>
                                <div className="md:col-span-4 flex items-center gap-4">
                                    <c.icon size={26} className="text-emerald-800 shrink-0 transition-transform duration-500 group-hover:-translate-y-1" />
                                    <h3 className="text-xl md:text-2xl font-bold tracking-tight text-stone-900">{c.titulo}</h3>
                                </div>
                                <p className="md:col-span-6 text-stone-600 text-base leading-relaxed">{c.texto}</p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
